const ListCouponPackages = () => import('@/modules/couponPackages/_pages/List');
const CreateCouponPackage = () => import('@/modules/couponPackages/_pages/Create');
import checkPermission from './checkPermission';

export default [
  /*
   * This screen now lives inside the Much+ section (CLIENTE-5139): it stopped
   * being its own menu item and became the "Pacotes de cupom avulso" tab.
   * The listing itself did not change.
   */
  {
    path: '/much-mais/pacotes-de-cupom',
    name: 'list-coupon-packages',
    component: ListCouponPackages,
    props: true,
    beforeEnter: checkPermission,
    meta: {
      isAvaliableInMenu: false,
      navbarTitle: 'Much+',
    },
  },
  {
    path: '/much-mais/pacotes-de-cupom/criar',
    name: 'create-coupon-packages',
    component: CreateCouponPackage,
    props: true,
    beforeEnter: checkPermission,
  },
  /* Backwards compatibility with the old URLs. */
  {
    path: '/pacote-de-cupons',
    redirect: { name: 'list-coupon-packages', },
  },
  {
    path: '/pacote-de-cupons/criar',
    redirect: { name: 'create-coupon-packages', },
  },
];
